<template>
  <div id="searchModal" class="modal">
    <div id="searchModalHeader" class="modalHeader">
      <div class="modalHeader_inner modal_layout">
        <p class="modalHeader_ttl">{{ modalTitle }}</p>

        <button
          type="button"
          class="modalHeader_icon"
          v-show="formMode === 'default'"
          @click="showOption"
        >
          <img src="@/assets/images/icon/search-option.svg" alt="" />
        </button>

        <button
          type="button"
          class="modalHeader_back"
          v-show="formMode !== 'default'"
          @click="formMode = 'default'"
        >
          戻る
        </button>

        <button
          type="button"
          class="modalHeader_close"
          @click="$store.dispatch('closeSearchModal')"
        >
          <img src="@/assets/images/icon/close-main.svg" alt="" />
        </button>
      </div>
    </div>

    <div
      class="modal_layout"
      :style="
        formMode === 'default' ? 'margin-top: 144px;' : 'margin-top: 72px;'
      "
    >
      <div v-show="formMode !== 'option'">
        <TabSeminar
          v-show="formMode === 'default'"
          class="tab"
          :list="tab"
          :current="currentTab"
          @click-tab="clickTab"
        />

        <HospitalSearchForm
          v-show="currentTab === 0"
          type="hospital"
          :formMode="formMode"
          :changeFormMode="changeFormMode"
          :scrollBarWidth="modalScrollBarWidth"
        />
        <HospitalSearchForm
          v-show="currentTab === 1"
          type="latter"
          :formMode="formMode"
          :changeFormMode="changeFormMode"
          :scrollBarWidth="modalScrollBarWidth"
        />
      </div>

      <div v-show="formMode === 'option'" style="padding-bottom: 60px">
        <SavedSearchCondition />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import TabSeminar from '@/components/elements/TabSeminar.vue'
import HospitalSearchForm from '@/components/block/HospitalSearchForm.vue'
import SavedSearchCondition from '@/components/block/SavedSearchCondition.vue'

export default defineComponent({
  components: {
    TabSeminar,
    SavedSearchCondition,
    HospitalSearchForm
  },

  setup() {
    const store = useStore()
    const formMode = ref('default')

    const tab = [
      {
        label: '病院・初期研修'
      },
      {
        label: '専門研修'
      }
    ]
    const defaultTab =
      store.state.userInfo?.member_type === '初期研修医' ? 1 : 0
    const currentTab = ref(defaultTab)
    const clickTab = (i: number) => (currentTab.value = i)
    const changeFormMode = (mode: string) => (formMode.value = mode)

    const modalTitle = computed(() => {
      if (formMode.value === 'option') return '検索オプション'
      if (formMode.value === 'area') return '病院所在地'
      return '病院検索'
    })

    // モーダルのヘッダーとフッターがスクロールバーに被らないようにする
    const modalScrollBarWidth = ref(0)
    onMounted(() => {
      const body = document.querySelector('body')
      const modal = document.getElementById('searchModal')

      if (body && modal) {
        const scrollBarWidth = body.clientWidth - modal.clientWidth
        const h = document.getElementById('searchModalHeader')
        if (h) h.style.width = `calc(100% - ${scrollBarWidth}px)`
        modalScrollBarWidth.value = scrollBarWidth
      }
    })

    const showOption = async () => {
      const isLogin = await store.dispatch('checkLogin')
      if (!isLogin) return

      formMode.value = 'option'
    }

    return {
      formMode,
      tab,
      currentTab,
      clickTab,
      changeFormMode,
      modalTitle,
      modalScrollBarWidth,
      showOption
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 999;
  // padding-bottom: 120px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.modal_layout {
  padding-right: 16px;
  padding-left: 16px;

  @include mixins.media() {
    margin-right: auto;
    margin-left: auto;
    padding-right: 20px;
    padding-left: 20px;
    max-width: 752px;
  }
}

.modalHeader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #fff;

  &_inner {
    height: 56px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  &_ttl {
    text-align: center;
    font-weight: 500;
    font-size: 2.2rem;
  }

  &_close {
    position: absolute;
    right: 16px;
    top: 50%;
    margin-top: -9px;

    img {
      width: 18px;
      height: 18px;
    }
  }

  &_icon {
    position: absolute;
    left: 16px;
    top: 50%;
    margin-top: -9px;
  }

  &_back {
    position: absolute;
    left: 16px;
    margin-top: 3px;
    display: flex;
    align-items: center;
    color: var.$color-main;

    &::before {
      content: '';
      display: block;
      width: 11px;
      height: 20px;
      background-image: url('~@/assets/icon/arrow-left-main.svg');
      background-size: 11px 20px;
      margin-right: 10px;
    }
  }

  &_searchCondition {
    @include mixins.media() {
      display: none;
    }
  }
}

.tab {
  margin-bottom: 48px;
}
</style>
